export default class AccountController {

  init() {
    this.$ = {
      menuNextSessions: document.querySelector('.account__menu__next-sessions'),
      menuHistory: document.querySelector('.account__menu__history'),
      nextSessions: document.querySelector('.account__next-sessions'),
      history: document.querySelector('.account__history'),
    }
    
    this._eventListeners()
  }

  _eventListeners() {
    this.$.menuNextSessions.addEventListener('click', () => { this._handleMenu(this.$.menuNextSessions) })
    this.$.menuHistory.addEventListener('click', () => { this._handleMenu(this.$.menuHistory) })
  }

  _handleMenu($menu) {
    this.$.menuNextSessions.classList.remove('active')
    this.$.menuHistory.classList.remove('active')
    this.$.nextSessions.classList.remove('active')
    this.$.history.classList.remove('active')
    if ($menu == this.$.menuNextSessions) {
      this.$.menuNextSessions.classList.add('active')
      this.$.nextSessions.classList.add('active')
    }
    if ($menu == this.$.menuHistory) {
      this.$.menuHistory.classList.add('active')
      this.$.history.classList.add('active')
    }
  }
}